import { Card } from "@/components/ui/card";
import { Shield, FileCheck, BarChart3, FileText, Settings } from "lucide-react";

const ComplianceCard = () => {
  const badges = [
    { label: "Registered Nonprofit", icon: Shield },
    { label: "12A · 80G · CSR-1", icon: FileCheck },
    { label: "Audited Financials", icon: BarChart3 },
    { label: "Institutional Reporting", icon: FileText },
    { label: "Operational Systems", icon: Settings }
  ];

  return (
    <section className="py-12 md:py-16 bg-white" data-testid="compliance-section">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Centered Container */}
        <div className="max-w-4xl mx-auto">
          <Card className="p-6 md:p-8 border-0 compliance-card text-white" data-testid="compliance-card">
            <h2 className="font-display text-2xl md:text-3xl font-bold mb-2 text-center">
              Institution-Ready by Design
            </h2>
            <p className="text-slate-400 text-sm mb-8 text-center">
              Built for seamless CSR compliance and reporting
            </p>
            
            <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
              {badges.map((badge, index) => (
                <div 
                  key={index}
                  className="flex flex-col items-center text-center p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors"
                  data-testid={`compliance-badge-${index}`}
                >
                  <div className="w-12 h-12 rounded-full bg-[#1F7A5A]/30 flex items-center justify-center mb-3">
                    <badge.icon className="w-6 h-6 text-[#4FB6A6]" />
                  </div>
                  <span className="text-sm font-medium text-white/90">{badge.label}</span>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ComplianceCard;
